// import InteractiveMap from 'components/interactiveHoverSection/InteractiveMap';
import './style.scss';
import { Filter } from './components/Filter';
import { ApartmentInfo } from 'components/ApartmentInfo';
import { useEffect, useState } from 'react';
import { BuildingRotation } from 'components/BuildingRotate';
import FullscreenPopup from 'components/PanoPopup/FullscreenPopup';
import { useDispatch, useSelector } from 'react-redux';
import { setIsPopupOpen, updateWorldParams } from 'store/actions';
import { APARTMENT_ADAPTER } from 'consts';
import { SettingControl } from 'components/SettingControl';
import { usePageTracking } from 'hooks/usePageTracking';

const SoDoTongThePage = () => {
  usePageTracking('masterplan');
  const dispatch = useDispatch();
  const { scenes } = useSelector((state) => state);
  const [showApartmentInfo, setShowApartmentInfo] = useState({
    isOpen: false,
    data: null,
  });
  const [filter, setFilter] = useState({
    type: 'can-ho',
    floor: '',
    apartmentType: '',
    usageArea: 100,
  });
  // eslint-disable-next-line
  const [vr, setVr] = useState({
    isOpen: false,
    sceneId: '',
  });
  const [clickedApartment, setClickedApartment] = useState(null);

  const handleResetFilter = () => {
    setFilter((prev) => ({
      ...prev,
      floor: '',
      apartmentType: '',
      usageArea: 100,
    }));
  };

  const handleShowVr = (sceneId) => {
    console.log('handleShowVr sceneId:', sceneId);
    setVr({ isOpen: true, sceneId });
    dispatch(setIsPopupOpen(true));

    // if (!window.isFirstVisitApartmentInfo) {
    //   dispatch(setGuideBoardVisible(true));
    //   window.isFirstVisitApartmentInfo = false;
    // }

    const scene = scenes.find((scene) => scene._id === sceneId);
    if (!scene) {
      console.error('Apartment scene not found');
      return;
    }

    dispatch(updateWorldParams({ sceneId: scene._id }));
  };

  useEffect(() => {
    return () => {
      setShowApartmentInfo({ isOpen: false, data: null });
      setVr({ isOpen: false, sceneId: '' });
    };
  }, []);

  return (
    <div className="so-do-tong-the-page">
      {showApartmentInfo.isOpen && (
        <ApartmentInfo
          data={showApartmentInfo.data}
          onBack={() => {
            setShowApartmentInfo({ isOpen: false, data: null });
            setClickedApartment(null);
          }}
          onWatchVRNavigate={() =>
            handleShowVr(APARTMENT_ADAPTER[showApartmentInfo.data.type].scene)
          }
        />
      )}
      <>
        <Filter
          filter={filter}
          setFilter={setFilter}
          onSelectScene={handleShowVr}
        />
        <BuildingRotation
          onShowApartmentInfo={(data) => {
            setShowApartmentInfo({ isOpen: true, data });
          }}
          filter={filter}
          onSelectScene={handleShowVr}
          onResetFilter={handleResetFilter}
          clickedApartment={clickedApartment}
          setClickedApartment={setClickedApartment}
        />
        <SettingControl />
      </>
      <FullscreenPopup
        isOpen={vr.isOpen}
        onClose={() => setVr({ isOpen: false, sceneId: '' })}
        sceneId={vr.sceneId}
      />
    </div>
  );
};

export default SoDoTongThePage;
